module.exports = __webpack_public_path__ + "img/alentour5.d766d2f0.jpg";